import React from "react";
import { useSelector } from "react-redux";
import Modal from "../../components/Modal";

const Assignment = () => {
  const { user } = useSelector((state) => state.auth);
  const [state, setState] = React.useState({
    url: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    // {
    //     "id": 1,
    //     "student_id": 2,
    //     "student_name": "Saad Hasan",
    //     "assignment_id": 1,
    //     "title": "Assignment 1 - Implement Debounce Function",
    //     "createdAt": "2021-01-15T15:17:01.727Z",
    //     "totalMark": 100,
    //     "mark": 0,
    //     "repo_link": "https://github.com/Learn-with-Sumit/assignment-1",
    //     "status": "pending"
    //   }
    const data = {
      ...state,
      student_id: user.id,
      student_name: user.name,
      //   assignment_id:
    };
    console.log("🚀 ~ file: AddVideo.js:6 ~ AddVideo ~ e", data);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <Modal>
      <form onSubmit={handleSubmit} style={{marginTop: "20px"}}>
        <div className="flex flex-row gap-4 mb-8 ">
          <div className="flex flex-col input-group" style={{ width: "100%" }}>
            <label htmlFor="url">Github Repository</label>
            <input
              type="text"
              name="url"
              id="url"
              placeholder="https://github.com/Learn-with-Sumit/assignment..."
              value={state.url}
              required
              onChange={handleChange}
            />
          </div>
        </div>

        <button className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 mx-auto">
          Submit Assignment
        </button>
      </form>
    </Modal>
  );
};

export default Assignment;
